// React
import React from "react";
import { connect } from "react-redux";
import * as appRouting from "appRouting";
// Components
import CardPanel from "common/ui/components/nav/cardPanel/CardPanel";
import Card from "common/ui/components/nav/cardPanel/Card";
// Helpers
import NamingHelper from "common/utils/namingHelper";
const mapStateToProps = (state, ownProps) => {
    return {
        officeId: ownProps.params && ownProps.params.officeId && parseInt(ownProps.params.officeId)
    };
};
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class SettingsOptions extends React.Component {
    render() {
        return (React.createElement(CardPanel, { title: NamingHelper.settings, titleColour: "#589AA4" },
            React.createElement(Card, { url: appRouting.profileUserPath(), label: NamingHelper.settingsMyProfile, description: "View your user profile details." }),
            React.createElement(Card, { url: appRouting.contactUsUrl(this.props.officeId), label: NamingHelper.settingsContactUs, description: "Contact our support team if you have any queries." })));
    }
}
export default connect(mapStateToProps)(SettingsOptions);
